document.addEventListener('click', function (event) {
  if (!event.target.closest('[data-toni-cookie-settings]')) return;
  var banner = document.querySelector('privacy-bar');
  if (!banner) return;
  banner.hidden = false;
  var firstButton = banner.querySelector('[data-action="accept"]');
  if (firstButton) firstButton.focus({preventScroll: true});
});
